var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"panel sidepanel"},[_c('p',{staticClass:"panel-heading"},[_vm._v("\n    "+_vm._s(_vm.header)+"\n  ")]),_vm._v(" "),_vm._l((_vm.items),function(item,index){return _c('div',{key:index,staticClass:"div-overflow"},[_c('a',{staticClass:"panel-block",class:{'is-active': _vm.selectedItemId == item.id},attrs:{"title":item.name},on:{"click":function($event){_vm.elementClick(item.id)}}},[_vm._v("    \n      "+_vm._s(item.name)+"\n    ")])])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/SideMenu.Vue?vue&type=template&id=129dd008
// module id = 145
// module chunks = 0